import { takeWhile } from 'rxjs/operators';
// Services
import { SupportService } from 'SupportApp/services/support.service';
import * as i0 from "@angular/core";
import * as i1 from "SupportApp/services/support.service";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
function SupportContactInfoPageComponent_div_3_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelement(1, "img", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", (ctx_r0.salesRep == null ? null : ctx_r0.salesRep.image_url) || "", i0.ɵɵsanitizeUrl);
} }
function SupportContactInfoPageComponent_div_3_a_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("href", ctx_r0.salesRep.meeting_url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("Book a Meeting with ", ctx_r0.salesRep.first_name, "");
} }
function SupportContactInfoPageComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 5);
    i0.ɵɵtext(2, " Get In Touch ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p", 16);
    i0.ɵɵtext(4, " Send a quick email or call directly for any questions you may have to speak with your dedicated support representative: ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 17);
    i0.ɵɵtemplate(6, SupportContactInfoPageComponent_div_3_div_6_Template, 2, 1, "div", 18);
    i0.ɵɵelementStart(7, "div", 19)(8, "div", 20);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 6)(11, "div", 7);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(12, "svg", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(13, "a", 21);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "div", 6)(16, "div", 7);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(17, "svg", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(18, "span", 11);
    i0.ɵɵtext(19);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(20, "div", 6)(21, "div", 7);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(22, "svg", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(23, SupportContactInfoPageComponent_div_3_a_23_Template, 2, 2, "a", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(24, "small");
    i0.ɵɵtext(25, "Office hours: Monday to Friday, from 9am to 6pm ET.");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelement(26, "hr", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r0.salesRep == null ? null : ctx_r0.salesRep.image_url);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2(" ", ctx_r0.salesRep == null ? null : ctx_r0.salesRep.first_name, " ", ctx_r0.salesRep == null ? null : ctx_r0.salesRep.last_name, " ");
    i0.ɵɵadvance(4);
    i0.ɵɵpropertyInterpolate1("href", "mailto:", ctx_r0.salesRep == null ? null : ctx_r0.salesRep.email, "", i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.salesRep == null ? null : ctx_r0.salesRep.email);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r0.salesRep == null ? null : ctx_r0.salesRep.phone_number);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.salesRep);
} }
function SupportContactInfoPageComponent_div_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 7);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(3, "a", 28);
    i0.ɵɵtext(4, "Live chat");
    i0.ɵɵelementEnd()();
} }
export class SupportContactInfoPageComponent {
    constructor(supportService) {
        this.supportService = supportService;
        this.showGetInTouch = false;
        this.chatEnabled = false;
        this.isAlive = true;
    }
    ngOnInit() {
        this.fetchSalesRep();
        window.hsChatEnabledSubject.pipe(takeWhile(() => this.isAlive)).subscribe(() => {
            this.chatEnabled = true;
        });
    }
    ngOnDestroy() {
        this.isAlive = false;
    }
    fetchSalesRep() {
        this.supportService.getSalesRep().subscribe({
            next: (data) => {
                this.salesRep = data;
                this.showGetInTouch = true;
            },
            error: () => {
                this.showGetInTouch = false;
            },
        });
    }
}
SupportContactInfoPageComponent.ɵfac = function SupportContactInfoPageComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SupportContactInfoPageComponent)(i0.ɵɵdirectiveInject(i1.SupportService)); };
SupportContactInfoPageComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SupportContactInfoPageComponent, selectors: [["ycn-support-contact-info-page"]], standalone: false, decls: 37, vars: 2, consts: [[1, "tab-pane", "active"], [1, "support-contact"], [4, "ngIf"], [1, "row"], [1, "col-6"], [1, "public-page-title"], [1, "support-contact-item"], [1, "support-contact-icon"], ["ycnIcon", "", "name", "icon-mail"], ["href", "mailto:support@ycharts.com", 1, "public-cta"], ["ycnIcon", "", "name", "icon-phone"], [1, "public-cta"], ["ycnIcon", "", "name", "icon-overview"], ["href", "https://ycharts.com/sales_support/contact", 1, "public-cta"], ["class", "support-contact-item", 4, "ngIf"], ["href", "mailto:sales@ycharts.com", 1, "public-cta"], [1, "public-intro"], [1, "row", "mb-5"], ["class", "col-auto", 4, "ngIf"], [1, "col", "support-contact-info"], [1, "public-h2"], [1, "public-cta", 3, "href"], ["ycnIcon", "", "name", "icon-team"], ["class", "public-cta", 3, "href", 4, "ngIf"], [1, "divider-horizontal", "mb-5"], [1, "col-auto"], [2, "height", "150px", 3, "src"], ["ycnIcon", "", "name", "icon-chat-small"], ["href", "javascript:void(0);", "onclick", "window.openHubSpotChat();", 1, "public-cta"]], template: function SupportContactInfoPageComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 1);
        i0.ɵɵtemplate(3, SupportContactInfoPageComponent_div_3_Template, 27, 8, "div", 2);
        i0.ɵɵelementStart(4, "div", 3)(5, "div", 4)(6, "div", 5);
        i0.ɵɵtext(7, " Customer Support ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 6)(9, "div", 7);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(10, "svg", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(11, "a", 9);
        i0.ɵɵtext(12, "support@ycharts.com");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(13, "div", 6)(14, "div", 7);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(15, "svg", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(16, "span", 11);
        i0.ɵɵtext(17, "(866) 965-7552");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(18, "div", 6)(19, "div", 7);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(20, "svg", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(21, "a", 13);
        i0.ɵɵtext(22, "Submit a question");
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(23, SupportContactInfoPageComponent_div_23_Template, 5, 0, "div", 14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(24, "div", 4)(25, "div", 5);
        i0.ɵɵtext(26, " Sales Team ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(27, "div", 6)(28, "div", 7);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(29, "svg", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(30, "a", 15);
        i0.ɵɵtext(31, "sales@ycharts.com");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(32, "div", 6)(33, "div", 7);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(34, "svg", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(35, "span");
        i0.ɵɵtext(36, "(866) 937-0776");
        i0.ɵɵelementEnd()()()()()()();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.showGetInTouch);
        i0.ɵɵadvance(20);
        i0.ɵɵproperty("ngIf", ctx.chatEnabled);
    } }, dependencies: [i2.NgIf, i3.IconDirective], encapsulation: 2 });
